<template>
  <div class="corporation_edit">
    <div
      v-for="headerTitle in headerTitles"
      :key="headerTitle.value"
      class="title_header"
      :style="{backgroundColor: headerTitle.color}"
    >
      <div
        class="title_header_value vertical_align_div"
        @click="pageLink(headerTitle.path)"
      >
        <span class="header_router">
          {{ headerTitle.value }}
        </span>
      </div>
    </div>
    <div class="corporation_notifications">
      <div class="corporation_notifications_background">
        <div class="assessment_title_label">
          {{ title }}
        </div>
        <div class="center">
          <table class="content_title" rules="rows">
            <tr class="items_table">
              <td class="table_no">
                <label>{{ noLabel }}</label>
              </td>
              <td class="table_contents">
                <label>{{ startDatetimeLabel }}</label>
              </td>
              <td class="table_contents">
                <label>{{ endDatetimeLabel }}</label>
              </td>
              <td class="table_contents">
                <label>{{ titleLabel }}</label>
              </td>
              <td class="table_contents">
                <label>{{ messageLabel }}</label>
              </td>
            </tr>
          </table>

          <div class="table_scroll">
            <table class="items_table" rules="rows">
              <tr
                class="item_table_row"
                v-for="(notification, index) in formatDateList"
                :key="notification.notificationId"
              >
                <td class="table_no">
                  <label>{{ index + 1 + (page - 1) * 20 }}</label>
                </td>
                <td class="table_contents">
                  <label>{{ notification.startDateTime }}</label>
                </td>
                <td class="table_contents">
                  <label>{{ notification.endDateTime }}</label>
                </td>
                <td class="table_contents">
                  <div class="message_area">{{ notification.title }}</div>
                </td>
                <td class="table_contents">
                  <div class="message_area">{{ notification.message }}</div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="bottom">
          <pagination
            v-model="page"
            :records="total"
            :per-page="pageSize"
            :options="{texts: {count: '{from} - {to}/{count}件'}, chunk: 5}"
            @paginate="setNotifications(page - 1)"
          >
          </pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from 'vue-pagination-2'

export default {
  data() {
    return {
      title: 'お知らせ登録履歴',
      noLabel: 'No.',
      startDatetimeLabel: '開始日時',
      endDatetimeLabel: '終了日時',
      titleLabel: 'タイトル',
      messageLabel: '表示メッセージ',
      pageSize: 20,
      page: 1,
      prevTotal: 0
    }
  },
  async created() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
    this.setNotifications(0)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    sysErrorMsg() {
      return this.$store.state.error.sysErrorMsg
    },
    headerTitles() {
      return this.$store.state.masters.detailHeaderTitle
    },
    notifications() {
      return this.$store.state.notifications.notifications
    },
    total() {
      if (
        (this.page - 1) * this.pageSize <=
        this.$store.state.notifications.total
      ) {
        return this.$store.state.notifications.total
      }
      return this.prevTotal
    },
    isOverPage() {
      return (
        (this.page - 1) * this.pageSize >= this.$store.state.notifications.total
      )
    },
    lastPage() {
      const last = Math.ceil(
        this.$store.state.notifications.total / this.pageSize
      )
      return last === 0 ? 1 : last
    },
    formatDateList() {
      var items = []
      for (let notification of this.notifications) {
        var item = Object()
        item.notificationId = notification.notificationId
        item.title = notification.title
        item.message = notification.message
        var s = new Date(notification.startDateTime)
        item.startDateTime =
          s.getFullYear() +
          '/' +
          this.padZero(s.getMonth() + 1) +
          '/' +
          this.padZero(s.getDate()) +
          '  ' +
          this.padZero(s.getHours()) +
          ':' +
          this.padZero(s.getMinutes()) +
          ':' +
          this.padZero(s.getSeconds())
        var e = new Date(notification.endDateTime)
        item.endDateTime =
          e.getFullYear() +
          '/' +
          this.padZero(e.getMonth() + 1) +
          '/' +
          this.padZero(e.getDate()) +
          '  ' +
          this.padZero(e.getHours()) +
          ':' +
          this.padZero(e.getMinutes()) +
          ':' +
          this.padZero(e.getSeconds())
        items.push(item)
      }
      return items
    }
  },
  components: {
    Pagination
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    pageLink(path) {
      this.$router.push(path)
    },
    async setNotifications(pageNo) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch(
          'notifications/setSelectedTenantNotifications',
          {
            tenantId: this.$store.state.systemAdminDefine.header.companyId,
            pageNo: pageNo
          }
        )
        if (this.isOverPage) {
          this.page = this.lastPage
        } else {
          this.page = pageNo + 1
        }
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode.sysErrorCode_670001
        this.createErrorMessage(error, eventNumber, 'MSGCRD0106')
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    createErrorMessage(error, eventNumber, errorNumber) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.header &&
        error.response.data.header.message
      ) {
        let errorMessage = error.response.data.header.message
        if (!errorMessage.indexOf('MSGCRD')) {
          this.failureWord =
            this.sysErrorMsg[errorMessage].name +
            this.sysErrorMsg[errorMessage].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          this.failureWord =
            this.sysErrorMsg[errorNumber].name +
            this.sysErrorMsg[errorNumber].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
      } else {
        this.failureWord =
          this.sysErrorMsg.MSGCRD0001.name +
          this.sysErrorMsg.MSGCRD0001.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
    },
    padZero(num) {
      return num < 10 ? '0' + num : num
    }
  }
}
</script>

<style scoped>
.table_contents {
  width: 22%;
}
.table_scroll {
  height: 96%;
}
.corporation_notifications_background {
  height: 790px;
}
.bottom {
  height: 53px;
  width: 100%;
  border-top: 1px solid #569292;
  background-color: #dbf5f1;
  position: sticky;
  bottom: auto;
}
.message_area {
  word-break: break-word;
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationNotifications.vue